import { render, staticRenderFns } from "./DCPOConfirm.vue?vue&type=template&id=0213743e&"
import script from "./DCPOConfirm.vue?vue&type=script&lang=js&"
export * from "./DCPOConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports